import * as echarts from 'echarts';
import i18n from "@/i18n"
import {
  showMessage
} from "@/utils/hooks/message"
import {
  getLangValue
} from "@/utils/common"; //获取后端语言
/* 圆形进度条 */
const circleEcharts = (options) => {
  let {
    chartDom,
    dataList,
    color
  } = options;
  let title = options.title || {}
  let myChart = chartDom && echarts.init(chartDom);
  let option = {
    color: color,
    title: [{
      text: dataList[0].value + '%',
      subtext: title.subtext || '',
      top: 'center',
      left: 'center',
      textStyle: {
        fontSize: title.fontSize || '12px',
        color: '#000', //圆环中心文字字体颜色
      }
    }],
    series: [{
      type: 'pie',
      radius: ['75%', '85%'], //控制圆环大小
      center: ['50%', '50%'], //控制圆环位置
      data: dataList,
      hoverAnimation: false,
      itemStyle: {
        normal: {
          borderWidth: 0
        }
      },
      labelLine: {
        normal: {
          length: 0,
          length2: 0,
          lineStyle: {
            color: '#e6e6e6'
          }
        }
      }
    }]
  };
  myChart && option && myChart.setOption(option)
}

/* 半圆型仪表盘 */
const halfRingChart = (options) => {
  let {
    chartDom,
    dataList,
    color
  } = options;
  let myChart = chartDom && echarts.init(chartDom);
  let chartPro = 0;
  dataList.substitute && dataList.substitute.forEach(sub => {
    chartPro += sub.cumulative_weight
  })
  let option = {
    color: color,
    title: [{
        text: dataList.process_alt + '%',
        left: 'center',
        top: '50%',
        textStyle: {
          color: '#000',
          fontSize: 13,
        }
      }, {
        text: `${parseFloat((dataList.cumulative_weight + chartPro).toFixed(3))} / ${dataList.dedatad_weight}(Ton)`,
        left: 'center',
        top: '65%',
        textStyle: {
          color: 'rgba(33, 37, 41, 0.64)',
          fontSize: 10
        }
      },
      {
        text: dataList.material_name || dataList.product_name,
        left: 'center',
        top: '78%',
        textStyle: {
          color: 'rgba(33, 37, 41, 0.64)',
          fontSize: 12
        }
      }
    ],
    angleAxis: {
      show: false,
      // 后面的180表示圆环的跨越的角度， 如max设置为100*360/270,startAngle设置为-135
      max: 100 * 360 / 180,
      type: 'value',
      startAngle: 180,
      splitLine: {
        show: false
      }
    },
    // 修改环形的宽度
    barMaxWidth: 5,
    radiusAxis: {
      show: false,
      type: 'category'
    },
    polar: {
      // 设置环形的位置
      center: ['50%', '66%'],
      // 设置环形大小
      radius: '120%'
    },
    series: [{
        type: 'bar',
        data: [dataList.process_alt > 100 ? 100 : dataList.process_alt],
        barGap: '-100%',
        coordinateSystem: 'polar',
        z: 3,
      },
      {
        type: 'bar',
        data: [100],
        barGap: '-100%',
        coordinateSystem: 'polar',
        z: 1,
      }
    ]
  }
  myChart && option && myChart.setOption(option)
}

/* 柱状图 */
const barChart = (options) => {
  let {
    chartDom,
    xAxisData,
    yAxisData
  } = options;
  let myChart = chartDom && echarts.init(chartDom);

  let option = {
    grid: {
      left: '0%', //默认10%
      right: '0%', //默认10%
      bottom: '2%', //默认60
      containLabel: true
      //grid区域是否包含坐标轴的刻度标签
    },
    title: [{
      text: 'Unit:(kg)',
      left: "0",
      top: "-5",
      textStyle: {
        fontSize: 12,
        color: '#000', //圆环中心文字字体颜色
      }
    }],
    tooltip: {
      trigger: 'axis',
      axisPointer: { // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      },
      formatter: function(params) {
        var res;
        var name;
        if (params && params[0].axisValue) {
          switch (params[0].axisValue) {
            case 'PW':
              name = 'Pre-Wash'
              break;
            case 'HC':
              name = 'Hydrocyclone'
              break;
            case 'SP':
              name = 'Screw Press '
              break;
            case 'WT':
              name = 'Water Treatment'
              break;
            case 'PRG':
              name = 'Purge'
              break;
          }
        }
        res = `
                    <div>${name}</div>
                    <div><span>${params[0].marker}</span>${params[0].data}</div>
                    `;
        return res
      }
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
      axisLine: {
        show: true, // 隐藏x轴轴线
      },
      axisTick: {
        show: true, // 隐藏坐标轴的刻度线
        alignWithLabel: true, // 图形于标题居中
        outSide: true, // 刻度线是指向内部还是外部
        length: 3, // x轴上指向标题刻度线的长度
      },
      axisLabel: {
        interval: 0,
        formatter: function(params) {
          var newParamsName = "";
          var paramsNameNumber = params.length;
          var provideNumber = 5; // 一行显示几个字 然后就超过字数就会自动换行
          var rowNumber = Math.ceil(paramsNameNumber / provideNumber);

          if (paramsNameNumber > provideNumber) {
            for (var p = 0; p < rowNumber; p++) {
              var tempStr = "";
              var start = p * provideNumber;
              var end = start + provideNumber;
              if (p == rowNumber - 1) {
                tempStr = params.substring(start, paramsNameNumber);
              } else {
                tempStr = params.substring(start, end) + "\n";
              }
              newParamsName += tempStr;
            }
          } else {
            newParamsName = params;
          }
          return newParamsName;
        },
        textStyle: {
          fontSize: 10
        },
      },
    },
    yAxis: {
      type: 'value',
    },
    series: [{
      data: yAxisData,
      type: 'bar'
    }]
  };

  myChart && option && myChart.setOption(option);
}

const maxNumber = 1

/* 雷达图 */
const radarChart = (options, platform = 'pc', type = 'hand') => {
  let {
    chartDom,
    data,
    color,
    name,
    ave
  } = options;
  let myChart = chartDom && echarts.init(chartDom);
  // 手感雷达图坐标指示名称
  let indicatorNames = [
    i18n.global.t('soft'),
    i18n.global.t('smooth'),
    i18n.global.t('warm'),
    i18n.global.t('radar_chart.total'),
  ]
  if (type === 'skin') {
    indicatorNames = [
      i18n.global.t('stiff'),
      i18n.global.t('prickle'),
      i18n.global.t('cool'),
      i18n.global.t('discomfort'),
    ]
  }
  // 雷达图标题
  let title = i18n.global.t('radar_chart.feel')
  if (type === 'skin') {
    title = i18n.global.t('radar_chart.skin_discomfort')
  }

  const indicator = [{
      // 需要替换成axisName
      // name: indicatorNames[0],
      name: indicatorNames[0],
      min: 0,
      max: maxNumber,
      // 坐标轴刻度标签的相关设置
      axisLabel: {
        show: true,
        formatter: function(value, index) {
          return index > 0 ? value : '';
        }
      }
    },
    {
      name: indicatorNames[1],
      min: 0,
      max: maxNumber,
      axisLabel: {
        show: true,
        formatter: function(value, index) {
          return index > 0 ? value : '';
        }
      }
    },
    {
      name: indicatorNames[2],
      min: 0,
      max: maxNumber,
      axisLabel: {
        show: true,
        // formatter: function (value, index) {
        //   return index > 0 ? value : '';
        // }
      }
    },
    {
      name: indicatorNames[3],
      min: 0,
      max: maxNumber,
      axisLabel: {
        show: true,
        formatter: function(value, index) {
          return index > 0 ? value : '';
        }
      }
    }
  ];
  let option = {
    title: {
      text: title,
      left: '10',
      top: '3',
      textStyle: {
        fontSize: 12,
        color: '#000',
        fontWeight: 'bold'
      }
    },
    backgroundColor: 'transparent',
    tooltip: {
      trigger: 'item',
    },
    legend: {
      orient: platform === 'pc' ? 'horizontal' : 'horizontal',
      icon: 'circle', //图例形状
      data: [name, i18n.global.t('radar_chart.average')],
      formatter: function(name) {
        let lineLength = platform === 'pc' ? 30 : 20
        if (name.length <= lineLength) return name
        let newName = ''
        let i = 0
        while (i < name.length) {
          newName += name.slice(i, i + lineLength) + '\n'
          i += lineLength
        }
        return newName
      },
      bottom: '0',
      left: 'center',
      // top: platform === 'pc' ? 35 : 10,
      // right: platform === 'pc' ? 35 : 10,
      itemWidth: 10, // 图例标记的图形宽度。[ default: 25 ]
      itemHeight: 10, // 图例标记的图形高度。[ default: 14 ]
      itemGap: 5, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
      textStyle: {
        fontSize: 12,
        color: '#A8A8A8',
      },
    },
    color: [color, '#000'],
    radar: {
      name: {
        color: '#A8A8A8',
        fontSize: 12,
        // textStyle: {
        //   color: '#A8A8A8',
        //   fontSize: 12,
        // },
        //指示器文字换行 start
        formatter: function(text) {
          // console.log(text);
          // var strlength = text.length;
          // if (strlength % 4 != 0) {
          //   text = text.replace(/\S{4}/g, function(match) {
          //     return match + '\n'
          //   })
          // } else {
          //   text = text.replace(/\S{4}/g, function(match) {
          //     return match + '\n'
          //   });
          //   strlength = text.length;
          //   text = text.substring(0, strlength - 1);
          // }
          text = text.replace(' ', '\n')
          return text
        },
      },
      splitNumber: 5,
      indicator: indicator,
      center: ['50%', '50%'], // 重新定位雷达图的中心位置
      radius: platform == 'pc' ? '65%' : '55%' // 调整雷达图大小
    },
    series: [{
        type: 'radar',
        symbolSize: 0,
        data: [{
          value: data,
          name: name,
          label: {
            show: false,
            formatter: (params) => {
              return params.value;
            },
            color: '#000',
            // normal: {
            //   show: false,
            //   formatter: (params) => {
            //     return params.value;
            //   },
            //   color: '#000',
            // },
          },
          areaStyle: {
            color: color,
            // normal: {
            //   color: color,
            // },
          },
          lineStyle: {
            opacity: 1,
            width: 1,
            // normal: {
            //   lineStyle: {
            //     width: 1,
            //   },
            //   opacity: 1,
            // },
          },
          emphasis: { // 折线拐点标志的样式。
            // normal: { // 普通状态时的样式
            lineStyle: {
              width: 1,
            },
            // },
            itemStyle: { // 高亮时的样式
              lineStyle: {
                width: 5,
              },
              opacity: 0,
            },
          },
        }, ],
      },
      /* 均值 */
      {
        type: 'radar',
        symbolSize: 0,
        data: [{
          value: ave,
          name: i18n.global.t('radar_chart.average'),
          label: {
            show: false,
            formatter: (params) => {
              return params.value;
            },
            color: '#919191',
          },
          lineStyle: {
            type: 'solid',
            lineStyle: {
              width: 1,
            },
            color: '#000',
            opacity: 1,
          },
          emphasis: { // 折线拐点标志的样式。
            lineStyle: {
              width: 1,
            },
            itemStyle: { // 高亮时的样式
              lineStyle: {
                width: 5,
              },
              opacity: 0,
            },
          },
        }, ],
      }
    ],
  }
  myChart && option && myChart.setOption(option);
}

const radar1Chart = (options, platform = 'pc') => {
  let {
    chartDom,
    data,
    color,
    name,
    ave
  } = options;
  let myChart = chartDom && echarts.init(chartDom);

  const indicator = [{
    name: i18n.global.t('radar_chart.comfort_value'),
    max: maxNumber,
    axisLabel: {
      show: true,
      formatter: function (value, index) {
        return index > 0 ? value : '';
      }
    },
  },
  {
    name: i18n.global.t('radar_chart.dampness_sensation'),
    max: maxNumber,
    axisLabel: {
      show: true,
      formatter: function (value, index) {
        return index > 0 ? value : '';
      }
    },
  },
  {
    name: i18n.global.t('radar_chart.thermal_sensation'),
    max: maxNumber,
    axisLabel: {
      show: true,
      // formatter: function (value, index) {
      //   return index > 0 ? value : '';
      // }
    },
  },
    // {
    //   name: i18n.global.t('radar_chart.total'),
    //   max: maxNumber,
    // }
  ];
  let option = {
    backgroundColor: 'transparent',
    tooltip: {
      trigger: 'item',
      confine: true,
    },
    legend: {
      orient: 'vertical',
      icon: 'circle', //图例形状
      data: [name, i18n.global.t('radar_chart.average')],
      // top: platform === 'pc' ? 35 : 10,
      // right: platform === 'pc' ? 40 : 10,
      itemWidth: 10, // 图例标记的图形宽度。[ default: 25 ]
      itemHeight: 10, // 图例标记的图形高度。[ default: 14 ]
      itemGap: 10, // 图例每项之间的间隔。[ default: 10 ]横向布局时为水平间隔，纵向布局时为纵向间隔。
      textStyle: {
        fontSize: 12,
        color: '#A8A8A8',
      },
      bottom: 10,
      right: platform === 'pc' ? 40 : 10,
      left: 20,
    },
    color: [color, '#000'],
    radar: {
      name: {
        color: '#A8A8A8',
        fontSize: 12,
        // textStyle: {
        //   color: '#A8A8A8',
        //   fontSize: 12,
        // },
        //指示器文字换行 start
        formatter: function (text) {
          // console.log(text);
          // var strlength = text.length;
          // if (strlength % 4 != 0) {
          //   text = text.replace(/\S{4}/g, function(match) {
          //     return match + '\n'
          //   })
          // } else {
          //   text = text.replace(/\S{4}/g, function(match) {
          //     return match + '\n'
          //   });
          //   strlength = text.length;
          //   text = text.substring(0, strlength - 1);
          // }
          text = text.replace(' ', '\n')
          return text
        },
      },
      //指示器文字换行 end
      splitNumber: 5,
      indicator: indicator,
    },
    series: [{
      type: 'radar',
      symbolSize: 0,
      data: [{
        // TODO:
        value: data,
        name: name,
        label: {
          show: false,
          formatter: (params) => {
            return params.value;
          },
          color: '#000',
          // normal: {
          //   show: false,
          //   formatter: (params) => {
          //     return params.value;
          //   },
          //   color: '#000',
          // },
        },
        areaStyle: {
          color: color,
          // normal: {
          //   color: color,
          // },
        },
        lineStyle: {
          opacity: 1,
          width: 1,
          // normal: {
          //   lineStyle: {
          //     width: 1,
          //   },
          //   opacity: 1,
          // },
        },
        emphasis: { // 折线拐点标志的样式。
          normal: { // 普通状态时的样式
            lineStyle: {
              width: 1,
            },
          },
          itemStyle: { // 高亮时的样式
            lineStyle: {
              width: 5,
            },
            opacity: 0,
          },
        },
      },],
    },
    /* 均值 */
    {
      type: 'radar',
      symbolSize: 0,
      data: [{
        // TODO:
        value: ave,
        name: i18n.global.t('radar_chart.average'),
        label: {
          show: false,
          formatter: (params) => {
            return params.value;
          },
          color: '#919191',
        },
        lineStyle: {
          type: 'solid',
          lineStyle: {
            width: 1,
          },
          color: '#000',
          opacity: 1,
        },
        emphasis: { // 折线拐点标志的样式。
          lineStyle: {
            width: 1,
          },
          itemStyle: { // 高亮时的样式
            lineStyle: {
              width: 5,
            },
            opacity: 0,
          },
        },
      },],
    }
    ],
  }
  myChart && option && myChart.setOption(option);
}

/* 桑基图 */
const sankeyChart = (options) => {
  let {
    chartDom
  } = options;
  let myChart = chartDom && echarts.init(chartDom);
  let datalist = [{
    name: "服装"
  },
  {
    name: "织物1"
  },
  {
    name: "织物2"
  },
  {
    name: "纱线1"
  },
  {
    name: "纤维1"
  },
  {
    name: "纱线2"
  },
  {
    name: "纤维2"
  },
  {
    name: "纱线11"
  },
  {
    name: "纱线22"
  },
  {
    name: "纱线33"
  },
  {
    name: "纤维11"
  },
  {
    name: "纤维22"
  },
  {
    name: "纤维33"
  },
  ];
  let linksData = [{
    source: "服装",
    target: "织物1",
    value: 1044305
  },
  {
    source: "服装",
    target: "织物2",
    value: 651527
  },
  {
    source: "织物1",
    target: "纱线1",
    value: 651527
  },
  {
    source: "织物1",
    target: "纤维1",
    value: 486710
  },
  {
    source: "织物2",
    target: "纱线2",
    value: 212670
  },
  {
    source: "织物2",
    target: "纤维2",
    value: 210400
  }, {
    source: "纱线1",
    target: "纱线11",
    value: 645246
  },
  {
    source: "纱线1",
    target: "纱线22",
    value: 513275
  },
  {
    source: "纱线1",
    target: "纱线33",
    value: 282986
  },
  {
    source: "纤维2",
    target: "纤维11",
    value: 118655
  },
  {
    source: "纤维2",
    target: "纤维22",
    value: 105989
  },
  {
    source: "纤维2",
    target: "纤维33",
    value: 95100
  },
  ];
  let option = {
    series: [{
      type: "sankey",
      top: '10%',
      nodeGap: 15,
      nodeWidth: 25,
      focusNodeAdjacency: "allEdges",
      data: datalist,
      links: linksData,
      label: {
        normal: {
          color: "#000",
          fontSize: 12,
        }
      },
      lineStyle: {
        normal: {
          opacity: 0.4,
          color: "source",
          curveness: 0.5
        }
      },
      itemStyle: {
        normal: {
          borderWidth: 1,
          borderColor: "transparent"
        }
      }
    }]
  };
  myChart && option && myChart.setOption(option);

  function resizeChart() {
    myChart.resize();
  }
  window.addEventListener('resize', resizeChart);
}

import router from '../router/index.js'
const getString = (text) => {
  // 分割字符串 太长了就换行
  const maxLineLength = 40; // 每行最多字符数
  let result = '';
  for (let i = 0; i < text.length; i += maxLineLength) {
    result += text.slice(i, i + maxLineLength) + '\n';
  }
  return result.trim();
}

// function setDepth(data, links, colors) {
//   const dataAll = {};
//   const colors_data = {};

//   const catergoryList = [...new Set(data.map(item => item.top_hscode_id))];
//   const catergoryList_data = {};

//   catergoryList.forEach((catId, catIndex) => {
//     colors_data[catId] = colors[catIndex] ?? '';
//     const groupData = data.filter(item => item.top_hscode_id === catId);
//     const groupNames = groupData.map(i => i.name);
//     const groupLinks = links.filter(link => groupNames.includes(link.source) && groupNames.includes(link.target));

//     // 初始化每个节点 depth 为 0
//     groupData.forEach(item => {
//       dataAll[item.name] = 0;
//     });

//     // 拓扑排序逻辑：只在同类中处理先后关系
//     let updated = true;
//     while (updated) {
//       updated = false;
//       for (const link of groupLinks) {
//         const { source, target } = link;
//         const sourceDepth = dataAll[source];
//         const targetDepth = dataAll[target];
//         if (targetDepth <= sourceDepth) {
//           dataAll[target] = sourceDepth + 1;
//           updated = true;
//         }
//       }
//     }

//     // 获取该分类最大 depth 起始值
//     const previousMaxDepth = Math.max(-1, ...Object.values(dataAll));
//     const offset = catIndex === 0 ? 0 : previousMaxDepth + 1;

//     // 所有节点 depth 加上 offset（用于避免多个分类重复列）
//     groupData.forEach(item => {
//       dataAll[item.name] += offset;
//     });

//     catergoryList_data[`cat_${catId}_list`] = groupData.map(i => dataAll[i.name]);
//   });
//   // 再设置一下层级
//   // 拓扑层级调整
//   let changed = true;
//   while (changed) {
//     changed = false;
//     for (const edge of links) {
//       const sourceLevel = dataAll[edge.source] ?? 0;
//       const targetLevel = dataAll[edge.target] ?? 0;
//       if (targetLevel <= sourceLevel) {
//         dataAll[edge.target] = sourceLevel + 1;
//         changed = true;
//       }
//     }
//   }
//   // 获取当前最小层级
//   const minLevel = Math.min(...Object.values(dataAll));

//   // 所有层级 - 最小层级（让最小变为0）
//   for (const key in dataAll) {
//     dataAll[key] -= minLevel;
//   }

//   console.log(dataAll);
//   return { dataAll, colors_data };
// }

function getValidLinks(links, nodes) {
  const nodeNames = new Set(nodes.map(node => node.name));
  return links.filter(link => nodeNames.has(link.source) && nodeNames.has(link.target));
}

function calculateNodeLevels(links, nodes) {
  const nodeMap = new Map();
  const levels = {};
  const inDegree = {};
  const graph = {};

  // 1. 建立节点信息
  for (const node of nodes) {
    nodeMap.set(node.name, node);
    graph[node.name] = [];
    inDegree[node.name] = 0;
  }

  // 2. 建图 + 入度统计
  for (const link of getValidLinks(links, nodes)) {
    const {
      source,
      target
    } = link;
    graph[source].push(target);
    inDegree[target]++;
  }

  // 3. 拓扑排序，初始化队列（入度为0）
  const queue = [];
  for (const node of nodes) {
    if (inDegree[node.name] === 0) {
      queue.push(node.name);
      levels[node.name] = 0;
    }
  }

  while (queue.length > 0) {
    const current = queue.shift();
    const currentLevel = levels[current];

    for (const neighbor of graph[current]) {
      inDegree[neighbor]--;
      // 层级为 source + 1
      levels[neighbor] = Math.max(levels[neighbor] || 0, currentLevel + 1);
      if (inDegree[neighbor] === 0) {
        queue.push(neighbor);
      }
    }
  }

  // 4. 同类型同步层级（不改变有source->target关系的）
  const typeGroups = {};
  for (const node of nodes) {
    const type = node.top_hscode_id;
    if (!typeGroups[type]) typeGroups[type] = [];
    typeGroups[type].push(node.name);
  }

  for (const group of Object.values(typeGroups)) {
    let minLevel = Infinity;
    for (const name of group) {
      if (levels[name] != null) {
        minLevel = Math.min(minLevel, levels[name]);
      }
    }

    for (const name of group) {
      if (levels[name] == null) {
        levels[name] = minLevel;
      }
    }
  }

  // 5. 从0开始归一化
  const allLevels = Object.values(levels);
  const min = Math.min(...allLevels);
  for (const key in levels) {
    levels[key] -= min;
  }

  return levels;
}



// const setDepth = (data, links, colors) => {
//   // 需要根据分类设置depth层级
//   // 先设置服装的
//   let dataAll = {}
//   let colors_data = {}
//   let catergoryList = [...new Set(data.map(item => item.top_hscode_id))].reverse(); // 现获取所有分类 反转排序
//   // console.log(catergoryList);
//   let catergoryList_data = {};
//   for (const key in catergoryList) {
//     colors_data[catergoryList[key]] = colors[key] ? colors[key] : ''
//     catergoryList_data[`key_${key}_start`] = key == 0 ? 0 : Math.max(...catergoryList_data[`key_${key - 1}_list`]) + 1;
//     catergoryList_data[`key_${key}_list`] = [];
//     let data1 = data.filter(item => item.top_hscode_id == catergoryList[key])
//     // console.log(data1);
//     for (const item in data1) {
//       const { name } = data1[item];
//       // 开始设置层级
//       // let arr = links.filter(item => item.target === name);
//       let arr = links.filter(item_link => item_link.target === name && data1.filter(item1 => item1.name == item_link.source).length)
//       let arr2 = arr.length ? data.filter(item_data => item_data.name === arr[0].source) : [];
//       if (arr.length && arr2.length && arr2[0].top_hscode_id == catergoryList[key]) {
//         // 一条数据
//         if (arr.length == 1) {
//           dataAll[name] = dataAll[arr[0].source] + 1 || catergoryList_data[`key_${key}_start`];
//         } else {
//           // 存在多条的情况  获取最大值
//           // console.log(arr);
//           let maxArr = arr.map(item_data => dataAll[item_data.source] || catergoryList_data[`key_${key}_start`])
//           // console.log(maxArr);
//           // console.log(name);
//           dataAll[name] = Math.max(...maxArr) + 1 || catergoryList_data[`key_${key}_start`]
//         }
//       } else {
//         dataAll[name] = catergoryList_data[`key_${key}_start`]
//       }
//       catergoryList_data[`key_${key}_list`].push(dataAll[name]);
//     }
//   }
//   return { dataAll, colors_data }
// }

const sankey1Chart = (options, listen = true, type = 'normal', showValue = false, to = 'productInfo', showType = 'value', category = '') => {
  let {
    chartDom,
    data,
    origin,
    nodeDataList = [],
    // databaseList
    title=""
  } = options;
  let myChart = chartDom && echarts.init(chartDom);
  let datalist = [];
  let linksData = [];
  let colors = [
    "#5470c6",
    "#91cc75",
    "#fac858",
    "#ee6666",
    "#73c0de",
    "#3ba272",
    "#fc8452",
    "#9a60b4",
    "#ea7ccc"
  ]
  // 修改信息
  // 服装 0  织物 1  纱线 2  纤维 3  废除了  现在按照大类 将大类的放在一起
  // let { dataAll, colors_data } = setDepth(data.nodes, data.links, colors)
  const result = calculateNodeLevels(data.links, data.nodes);
  // console.log(result);
  data.nodes.map(item => {
    // 设置depath
    item.depth = result[item.name]
    // 根据大类设置颜色
    if (colors[result[item.name]]) {
      item.itemStyle = {
        color: colors[result[item.name]],
      }
    }
  })
  // 获取数据
  datalist = data.nodes
  linksData = data.links
  // 超过10条就动态计算高度
  if (type == 'normal' && datalist.length > 10) {
    const nodeCount = datalist.length; // 假设 data 是你的节点数组
    const chartHeight = Math.max(800, nodeCount * 30); // 每个节点预留 50px 高度
    chartDom.style.height = `${chartHeight}px`;
  }
  let option = {
    // tooltip: {
    //   trigger: 'item',
    //   formatter: "{c}",
    // },
    title: {
      text: title,
      left: 'left',
      top: 20,
    },
    color: colors,
    grid: {
      // left: 'center', // 设置左边距为居中
      // right: 'center', // 设置右边距为居中
      containLabel: true // 确保标签也在网格区域内
    },
    series: [{
      type: "sankey",
      top: '2%',
      layout: 'none', // 禁用自动布局
      nodeGap: 30,
      draggable: false,
      // layoutIterations: 32,
      nodeAlign: 'justify', // 自动分布节点
      emphasis: {
        focus: 'adjacency', label: {
          show: type == 'normal' ? true : false,
        }
      },
      data: datalist,
      links: linksData,
      // 根据depth 设置颜色
      // levels: colors.map((item, index) => {
      //   return {
      //     depth: index,
      //     itemStyle: {
      //       color: item
      //     },
      //     lineStyle: {
      //       color: 'source',
      //       opacity: 0.6
      //     }
      //   }
      // }),
      label: {
        color: "#000",
        fontSize: 12,
        lineHeight: 20,
        show: type == 'normal' ? true : false,
        formatter: params => {
          if (nodeDataList.length) {
            let obj = nodeDataList.find(item => item.name == params.name)
            if (showType == 'value') {
              // 大部分板子 都是value  质量没有
              if (obj.database) {
                let text = showValue && obj.database?.value !== '' && obj.database?.value != null ? `${params.name} : ${obj.database?.value}` : `${params.name}`
                return getString(text);
              }
            }
          }
          let text = `${params.name}`
          return getString(text);

        },
        rich: {},
      },
      lineStyle: {
        opacity: 0.4,
        color: "source",
        curveness: 0.5
        // normal: {
        //   opacity: 0.4,
        //   color: "source",
        //   curveness: 0.5
        // }
      },
      itemStyle: {
        borderWidth: 1,
        borderColor: "transparent"
        // normal: {
        //   borderWidth: 1,
        //   borderColor: "transparent"
        // }
      },
    }]
  };
  myChart && option && myChart.setOption(option);
  // 监听大小变化
  function resizeChart() {
    myChart.resize();
  }
  window.addEventListener('resize', resizeChart);
  // 监听finished事件
  // myChart.getZr().on('rendered', function () {
  //   // 获取配置项
  //   const nodes = option.series[0].data;
  //   // 遍历节点获取坐标
  //   const nodePositions = {};
  //   nodes.forEach(node => {
  //     const pixel = myChart.convertToPixel({ seriesIndex: 0 }, [node.name]);
  //     if (pixel) {
  //       nodePositions[node.name] = { x: pixel[0], y: pixel[1] };
  //     }
  //   });
  //   console.log(nodePositions);
  // });
  // 部分页面不需要跳转
  if (listen && type == 'normal') {
    myChart.on('click', function (params) {
      // clickable 代表这个是否可以点击跳转  跳转到产品 或者 跳转到对应面板
      if (params.dataType == 'node' && params.data && params.data.clickable) {
        const data = params.data
        const { node_type: table_name, unique_id: target_id, template_name, } = data
        if (to == 'productInfo') {
          // 跳转到产品信息
          // 进行比对 table_name
          if (!template_name) {
            showMessage('danger', getLangValue('product-management', 'loseTemplateName'))
          } else {
            let url = router.resolve({
              path: '/products_info',
              query: {
                id: target_id,
                t_name: table_name,
                tid: template_name,
                origin: origin
              }
            }).href
            window.open(url, '_blank')
          }
        } else {
          // 跳转到对应板子
          let query = {}
          let dict = {
            category_1: '/dashboard-traceability-digital-passport',
            category_2: '/dashboard-comfort-digital-passport',
            category_3: '/dashboard-quality-digital-passport',
            category_4: '/dashboard-circularity-digital-passport',
            category_5: '/dashboard-environment-digital-passport',
            category_6: '/dashboard-esg-digital-passport',
          }
          if (category == 1) {
            // 可追溯性 参数少一些
            query = { id: target_id }
          } else {
            // 奇特几个信息 多几个参数
            let obj = nodeDataList.find(item => item.database?.id === target_id)
            // 把pid传过去保证唯一
            query = {
              product_template_name: [obj.database?.production_line?.database_template.name,
              obj.database?.production_line?.database_template?.destination_market?.id],
              keyword: obj.database?.pid, hscode: obj.database?.production_line.database_template?.hscode?.id,
            }
          }
          let url = router.resolve({ path: dict[`category_${category}`], query: query }).href
          window.open(url, '_blank')
        }

      }
      if(!params.data.clickable){
        showMessage('danger', getLangValue('product-management', 'clickableFalse'))
        return
      }
    });

  }
  myChart.resize()
  return myChart

  // function jumpToDetail(chooseType, current_tab, detail_tab, target_id, to, dataType = '') {
  //   if (chooseType) {
  //     setTimeout(() => {
  //       router.push(`/${to}/?id=${target_id}&type=view&current_tab=${current_tab}&detail_tab=${detail_tab}&chooseType=${chooseType}&data_type=${dataType}`);
  //     }, 0)
  //   } else {
  //     setTimeout(() => {
  //       router.push(`/${to}/?id=${target_id}&type=view&data_type=${dataType}`);
  //     }, 0)
  //   }
  // }
}

const sankey2Chart = (options, listen = true, type = 'normal', showType = 'value',) => {
  // 可追溯性使用
  let {
    chartDom,
    data,
    // origin,
    nodeDataList = [],
    // databaseList
    title = ''
  } = options;
  let myChart = chartDom && echarts.init(chartDom);
  let datalist = [];
  let linksData = [];
  let colors = [
    "#5470c6",
    "#91cc75",
    "#fac858",
    "#ee6666",
    "#73c0de",
    "#3ba272",
    "#fc8452",
    "#9a60b4",
    "#ea7ccc"
  ]
  datalist = data.nodes
  linksData = data.links
  // 服装 0  织物 1  纱线 2  纤维 3  废除了  现在按照大类 将大类的放在一起
  // 设置分类depth
  // let { dataAll, colors_data } = setDepth(data.nodes, data.links, colors)
  // 根据大类设置颜色
  const result = calculateNodeLevels(data.links, data.nodes);
  // console.log(result);
  data.nodes.map(item => {
    // 设置depath
    item.depth = result[item.name]
    // 根据大类设置颜色
    if (colors[result[item.name]]) {
      item.itemStyle = {
        color: colors[result[item.name]],
      }
    }
  })
  // data.nodes.map(item => {
  //   item.depth = dataAll[item.name]
  //   if (colors_data[item.top_hscode_id]) {
  //     item.itemStyle = {
  //       color: colors_data[item.top_hscode_id],
  //     }
  //   }
  // })
  // 超过10条就动态计算高度
  if (type == 'normal' && datalist.length > 10) {
    const nodeCount = datalist.length; // 假设 data 是你的节点数组
    const chartHeight = Math.max(800, nodeCount * 30); // 每个节点预留 50px 高度
    chartDom.style.height = `${chartHeight}px`;
  }

  let option = {
    // tooltip: {
    //   trigger: 'item',
    //   formatter: "{c}",
    // },
    title: {
      text: title,
      left: 'left',
      top: 20,
    },
    color: colors,
    grid: {
      left: 'center', // 设置左边距为居中
      right: 'center', // 设置右边距为居中
      containLabel: true // 确保标签也在网格区域内
    },
    tooltip: type == 'normal' && showType == 'value' ? {
      trigger: 'item',
      formatter: params => {
        if (params.dataType === 'edge' && typeof params.data.percentage != 'undefined') {
          return `${params.data.source} → ${params.data.target}<br>Percentage: ${params.data.percentage}%`;
        }
        let obj = nodeDataList.find(item => item.name == params.data.target);
        if (params.dataType === 'edge' && typeof obj != 'undefined' && obj.database?.value !== '' && obj.database?.value != null) {
          return `${params.name}<br>${params.data.target}:${obj.database?.value}`;
        }
        return `${params.name}`;
      }
    } : null,
    series: [{
      type: "sankey",
      top: '20%',
      nodeGap: 30,
      nodeWidth: 25,
      draggable: false,
      emphasis: {
        focus: 'adjacency', label: {
          show: type == 'normal' ? true : false,
        }
      },
      data: datalist,
      links: linksData,
      label: {
        color: "#000",
        fontSize: 12,
        show: type == 'normal' ? true : false,
        // normal: {
        //   color: "#000",
        //   fontSize: 12,
        // }
        formatter: params => {
          let str = ''
          if (nodeDataList.length) {
            if (showType == 'value') {
              // 显示比例
              const relevantLinks = data.links.filter(link => link.target === params.name && link.percentage);
              // 如果关联了2个或以上
              if (relevantLinks.length > 1) {
                str += `${params.name}\n\n` + relevantLinks
                  .map(link => `${link.source}: ${link.percentage}%`)
                  .join('\n\n');
                return str;
              } else if (relevantLinks.length > 0) {
                // 只有一个比例
                let text = `${params.name}:${relevantLinks[0].percentage}%`
                return getString(text);
              } else {
                // 显示数值
                let text = params.data?.database?.value !== '' && params.data?.database?.value != null ? `${params.name}:${params.data.database.value}` : `${params.name}`
                return getString(text);
              }
            }
            // 显示产地
            if (showType == 'place') {
              let obj = nodeDataList.find(item => item.name == params.name)
              let place = obj.database?.production_line?.place_of_origin?.name;
              str += `${params.name} : ${place}`
            }
            let text = str ? str : `${params.name}`
            return getString(text);

          }
          let text = `${params.name}`
          return getString(text);
        },
        rich: {} // 用于动态更新样式
      },
      // 根据depth 设置颜色
      levels: colors.map((item, index) => {
        return {
          depth: index,
          itemStyle: {
            color: item
          },
          lineStyle: {
            color: 'source',
            opacity: 0.6
          }
        }
      }),
      lineStyle: {
        opacity: 0.4,
        color: "source",
        curveness: 0.5
        // normal: {
        //   opacity: 0.4,
        //   color: "source",
        //   curveness: 0.5
        // }
      },
      itemStyle: {
        borderWidth: 1,
        borderColor: "transparent"
        // normal: {
        //   borderWidth: 1,
        //   borderColor: "transparent"
        // }
      },
    }]
  };
  myChart && option && myChart.setOption(option);
  // 监听大小变化
  function resizeChart() {
    myChart.resize();
  }
  window.addEventListener('resize', resizeChart);
  // 监听finished事件
  // myChart.getZr().on('rendered', function () {
  //   // 获取配置项
  //   const nodes = option.series[0].data;
  //   // 遍历节点获取坐标
  //   const nodePositions = {};
  //   nodes.forEach(node => {
  //     const pixel = myChart.convertToPixel({ seriesIndex: 0 }, [node.name]);
  //     if (pixel) {
  //       nodePositions[node.name] = { x: pixel[0], y: pixel[1] };
  //     }
  //   });
  //   console.log(nodePositions);
  // });
  // 部分页面不需要跳转
  if (listen && type == 'normal') {
    myChart.on('click', function (params) {
      // clickable 代表这个是否可以点击跳转  跳转到产品 或者 跳转到对应面板
      if (params.dataType == 'node' && params.data && params.data.clickable) {
        const data = params.data
        const { unique_id: target_id, } = data
        // 跳转到对应板子
        let query = {}
        let dict = {
          category_1: '/dashboard-traceability-digital-passport',
        }
        // 可追溯性 参数少一些
        query = { id: target_id }
        let url = router.resolve({ path: dict[`category_1`], query: query }).href
        window.open(url, '_blank')
      }
    });

    // 设置鼠标悬停事件
    myChart.on('mouseover', params => {
      if (params.dataType === 'edge') {
        // 高亮悬停的链接对应的文字
        const hoveredSource = params.data.source;
        // const hoveredTarget = params.data.target;

        const updatedRich = {};
        updatedRich[`${hoveredSource}Style`] = {
          color: 'red', // 高亮颜色
          fontWeight: 'bold'
        };

        // 动态更新 rich 样式
        myChart.setOption({
          series: [
            {
              label: {
                rich: updatedRich
              }
            }
          ]
        });
      }
    });

    myChart.on('mouseout', () => {
      // 恢复默认样式
      myChart.setOption({
        series: [
          {
            label: {
              rich: {}
            }
          }
        ]
      });
    });

  }
  myChart.resize()
  return myChart

  // function jumpToDetail(chooseType, current_tab, detail_tab, target_id, to, dataType = '') {
  //   if (chooseType) {
  //     setTimeout(() => {
  //       router.push(`/${to}/?id=${target_id}&type=view&current_tab=${current_tab}&detail_tab=${detail_tab}&chooseType=${chooseType}&data_type=${dataType}`);
  //     }, 0)
  //   } else {
  //     setTimeout(() => {
  //       router.push(`/${to}/?id=${target_id}&type=view&data_type=${dataType}`);
  //     }, 0)
  //   }
  // }
}

/* 可拖拽雷达图 */

const dragRadarChart = (options, calback) => {
  let {
    chartDom,
    color,
    chartData,
    type
  } = options;
  let myChart = chartDom && echarts.init(chartDom);
  const symbolSize = 10;
  /* point 上｜左｜下｜右 */
  const data = [
    [0, 10],
    [-10, 0],
    [0, -10],
    [10, 0]
  ];
  const data1 = chartData
  const indicator = [{
    name: i18n.global.t('radar_chart.softness'),
    max: 10,
  },
  {
    name: i18n.global.t('radar_chart.roughness'),
    max: 10
  },
  {
    name: i18n.global.t('radar_chart.warmth'),
    max: 10
  },
  {
    name: i18n.global.t('radar_chart.total'),
    max: 10
  }
  ];
  let option = {
    tooltip: {
      triggerOn: 'none',
      formatter: function (params) {
        let key = null;
        switch (params.dataIndex) {
          case 0:
            key = i18n.global.t('radar_chart.softness')
            break
          case 1:
            key = i18n.global.t('radar_chart.roughness')
            break
          case 2:
            key = i18n.global.t('radar_chart.warmth')
            break
          case 3:
            key = i18n.global.t('radar_chart.total')
            break
        }
        return `${key}`
      }
    },
    grid: {
      top: '12%',
      bottom: '12%',
      right: '28%',
      left: '28%'
    },
    xAxis: {
      min: -10,
      max: 10,
      type: 'value',
      show: false,
      axisLine: {
        onZero: true
      }
    },
    yAxis: {
      min: -10,
      max: 10,
      type: 'value',
      show: false,
      axisLine: {
        onZero: true
      }
    },
    radar: {
      axisName: {
        color: '#A8A8A8',
        fontSize: 12,
        //指示器文字换行 start
        formatter: function (text) {
          var strlength = text.length;
          if (strlength % 4 != 0) {
            text = text.replace(/\S{4}/g, function (match) {
              return match + '\n';
            });
          } else {
            text = text.replace(/\S{4}/g, function (match) {
              return match + '\n';
            });
            strlength = text.length;
            text = text.substring(0, strlength - 1);
          }
          return text;
        }
        //指示器文字换行 end
      },

      indicator: indicator
    },
    color: color,
    series: [{
      type: 'line',
      smooth: false,
      lineStyle: {
        width: 0
      },
      symbolSize: 0,
      data: data
    },
    {
      type: 'radar',
      symbolSize: 0,
      data: [{
        // TODO:
        value: data1,
        label: {
          show: true,
          formatter: (params) => {
            return params.value;
          },
          color: '#000'
        },
        areaStyle: {
          color: color,
          opacity: 0.2
        },
        lineStyle: {
          width: 1,
          opacity: 0.5
        }
      },

      ]
    }
    ]
  };
  setTimeout(function () {
    // Add shadow circles (which is not visible) to enable drag.
    myChart.setOption({
      graphic: data.map(function (item, dataIndex) {
        return {
          type: 'circle',
          position: myChart.convertToPixel('grid', item),
          shape: {
            cx: 0,
            cy: 0,
            r: symbolSize / 2
          },
          style: {
            fill: "#fff",
            stroke: color
          },
          invisible: false,
          draggable: true,
          ondrag: function (e) {
            onPointDragging(dataIndex, [this.x, this.y], e);
          },
          ondragend: () => {
            /* 结束操作后｜回调数据 */
            calback && calback({
              type: type,
              data: data1
            })
          },
          onmousemove: function () {
            showTooltip(dataIndex);
          },
          onmouseout: function () {
            hideTooltip(dataIndex);
          },
          z: 100
        };
      })
    });
  }, 0);

  function showTooltip(dataIndex) {
    myChart.dispatchAction({
      type: 'showTip',
      seriesIndex: 0,
      dataIndex: dataIndex
    });
  }

  function hideTooltip(dataIndex) {
    myChart.dispatchAction({
      type: 'hideTip',
      seriesIndex: 0,
      dataIndex: dataIndex
    });
  }

  function onPointDragging(dataIndex, pos, e) {
    let positionX = myChart.convertFromPixel('grid', pos)[0]
    let positionY = myChart.convertFromPixel('grid', pos)[1]
    /* Y轴操作 */
    if (dataIndex == 0 || dataIndex == 2) {
      if (positionY >= -10 && positionY <= 10) {
        data[dataIndex][1] = positionY
        if (dataIndex == 0) {
          data1[dataIndex] = Number(positionY.toFixed(1))
        } else {
          data1[dataIndex] = Number(-(positionY.toFixed(1)))
        }
      } else if (positionY == -10) {
        data[dataIndex][1] = -10
        data1[dataIndex] = 10
      } else if (positionY == 10) {
        data[dataIndex][1] = 10
        data1[dataIndex] = 10
      }
      /* 控制移动y轴的范围 */
      e.target.x = 200
      if (e.target.y < 28) {
        e.target.y = 28
      } else if (e.target.y >= 28 && e.target.y >= 202) {
        e.target.y = 203
      }
    }
    /* X轴操作 */
    if (dataIndex == 1 || dataIndex == 3) {
      if (positionX >= -10 && positionX <= 10) {
        data[dataIndex][0] = positionX
        if (dataIndex == 3) {
          data1[dataIndex] = Number(positionX.toFixed(1))
        } else {
          data1[dataIndex] = Number(-(positionX.toFixed(1)))
        }
      } else if (positionX == -10) {
        data[dataIndex][0] = -10
        data1[dataIndex] = 10
      } else if (positionX == 10) {
        data[dataIndex][0] = 10
        data1[dataIndex] = 10
      }
      /* 控制移动x轴的范围 */
      e.target.y = 115
      if (e.target.x < 113) {
        e.target.x = 112
      } else if (e.target.x >= 113 && e.target.x >= 288) {
        e.target.x = 289
      }

    }
    // Update data
    myChart.setOption({
      series: [{
        type: 'line',
        smooth: false,
        lineStyle: {
          width: 0
        },
        symbolSize: 0,
        data: data
      },
      {
        type: 'radar',
        symbolSize: 0,
        data: [{
          // TODO:
          value: data1,
          label: {
            show: true,
            formatter: (params) => {
              return params.value;
            },
            color: '#000'
          },
          areaStyle: {
            color: color,
            opacity: 0.2
          },
          lineStyle: {
            width: 1,
            opacity: 0.5
          }
        },
        ]
      }
      ]
    });
  }

  myChart && option && myChart.setOption(option);
}

const dashbordChart1 = (chartDom, option) => {
  var myChart = echarts.init(chartDom);
  option && myChart.setOption(option, true);
  return myChart
}

//指标雷达图
const drawRadar = (chartDom, option) => {
  var myChart = echarts.init(chartDom);
  option && myChart.setOption(option, true);
  function resizeChart() {
    myChart.resize();
  }
  window.addEventListener('resize', resizeChart);
  return myChart
}

const clearChart = (dom) => {
  var chart = echarts.init(dom);
  chart.clear();
}

export {
  circleEcharts,
  halfRingChart,
  barChart,
  radarChart,
  radar1Chart,
  sankeyChart,
  sankey1Chart,
  dragRadarChart,
  dashbordChart1,
  drawRadar,
  clearChart,
  sankey2Chart
}